import { DeliveryState } from "../../../type/delivery-state";

export const clearControlDeliveriesDispatch = (state: DeliveryState) => {
  state.controlDeliveries = [];
};
